import { Sliders, Calculator, LayoutDashboard, FileText, Users, Workflow, BookOpen, ChartNoAxesCombined, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { useLang } from "@/i18n/LanguageContext";
import { BUSINESS_PATHS, inquireAboutPath } from "@/lib/businessPaths";

const ICONS = [Sliders, Calculator, LayoutDashboard, FileText, Users, Workflow, BookOpen, ChartNoAxesCombined];

export const UseCasesSection = () => {
  const { t } = useLang();
  const c = t.cases;
  return (
    <section id="cases" className="relative scroll-mt-24 py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid bg-grid-fade pointer-events-none" />
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        <SectionHeading eyebrow={c.eyebrow} title={c.title} intro={c.intro} testId="usecases-heading" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="usecases-grid">
          {c.items.map((it, i) => {
            const Icon = ICONS[i];
            return (
              <a key={i} href="#kontakt" onClick={() => inquireAboutPath(it.path)} aria-label={`${it.title}: ${c.cta}`} title={c.cta} className="group block min-w-0 glass-card hover-lift rounded-2xl p-6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--cyan)]" data-testid={`usecase-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-11 w-11 rounded-xl border border-[var(--line)] bg-white/[0.03] text-[var(--blue-bright)] group-hover:text-[var(--green)] transition-colors duration-300">
                    <Icon size={20} />
                  </span>
                  <ArrowUpRight size={16} className="text-[var(--muted-2)] group-hover:text-[var(--white)] transition-colors duration-300" />
                </div>
                <p className="mt-5 text-[10px] font-mono uppercase text-[var(--green)]" data-testid={`usecase-path-${i}`}>{t.businessPaths.items[BUSINESS_PATHS.findIndex((path) => path.key === it.path)].title}</p>
                <h3 className="mt-2 font-display font-semibold text-[var(--white)] leading-snug" data-testid={`usecase-title-${i}`}>{it.title}</h3>
                <p className="mt-2 text-sm text-muted leading-relaxed" data-testid={`usecase-description-${i}`}>{it.desc}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
